import React from "react";

import PropTypes from "prop-types";

import RbCheckboxGroup from "../RbCheckboxGroup";
import RbControl from "../RbControl";

const RbCheckboxGroupControl = React.forwardRef(function RbCheckboxGroupControl(
  props,
  ref
) {
  const {
    defaultValue,
    name,
    onChange,
    onChangeValue,
    options,
    value,
    variant,
    ...other
  } = props;

  return (
    <RbControl
      ref={ref}
      renderComponent={(params) => (
        <RbCheckboxGroup
          {...params}
          defaultValue={defaultValue}
          name={name}
          onChange={onChange}
          onChangeValue={onChangeValue}
          options={options}
          value={value}
          variant={variant}
        />
      )}
      {...other}
    />
  );
});

RbCheckboxGroupControl.propTypes = {
  component: PropTypes.string,
  defaultValue: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.number,
    PropTypes.string,
  ]),
  InputLabelProps: PropTypes.object,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onChangeValue: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string,
    })
  ),
  value: PropTypes.any,
  variant: PropTypes.oneOf(["column", "row"]),
};

RbCheckboxGroupControl.defaultProps = {
  defaultValue: undefined,
  name: undefined,
  onChange: undefined,
  onChangeValue: undefined,
  options: undefined,
  value: undefined,
  component: "fieldset",
  InputLabelProps: {
    component: "legend",
  },
  variant: undefined,
};

export default React.memo(RbCheckboxGroupControl);
